import { render, staticRenderFns } from "./test-home.vue?vue&type=template&id=75147987&scoped=true"
import script from "./test-home.vue?vue&type=script&lang=ts"
export * from "./test-home.vue?vue&type=script&lang=ts"
import style0 from "./test-home.vue?vue&type=style&index=0&id=75147987&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75147987",
  null
  
)

export default component.exports